import { InstalledEquipment } from './appointmentEquipment.models';

export interface AppointmentEquipmentState {
  ids: string[];
  entities: Record<string, InstalledEquipment>;
  selectedLocationId: string | null;
  error: string | null;
  isLoaded: boolean;
  isLoading: boolean;
}

type Action =
  | { type: 'FETCH_INSTALLED_EQUIPMENT'; payload: { locationId: string } }
  | {
      type: 'FETCH_INSTALLED_EQUIPMENT_SUCCESS';
      payload: {
        installedEquipment: InstalledEquipment[];
      };
    }
  | { type: 'FETCH_INSTALLED_EQUIPMENT_FAILURE'; payload: { error: string } }
  | { type: 'FETCH_INSTALLED_EQUIPMENT_CANCELLED' }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const initState: AppointmentEquipmentState = {
  ids: [],
  entities: {},
  selectedLocationId: null,
  error: null,
  isLoaded: false,
  isLoading: false,
};

export const appointmentEquipmentReducer = (
  state: AppointmentEquipmentState,
  action: Action
): AppointmentEquipmentState => {
  switch (action.type) {
    case 'FETCH_INSTALLED_EQUIPMENT':
      return {
        ...state,
        error: null,
        isLoading: true,
        isLoaded: !!state.ids.length,
        selectedLocationId: action.payload.locationId,
      };

    case 'FETCH_INSTALLED_EQUIPMENT_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ids: [
          ...new Set([
            ...state.ids,
            ...action.payload.installedEquipment.map(
              (a) => a.locationEquipmentId
            ),
          ]),
        ],
        entities: action.payload.installedEquipment.reduce(
          (prev, curr) =>
            Object.assign(prev, { [curr.locationEquipmentId]: curr }),
          state.entities
        ),
      };

    case 'FETCH_INSTALLED_EQUIPMENT_FAILURE':
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.payload.error,
      };

    case 'FETCH_INSTALLED_EQUIPMENT_CANCELLED':
      return {
        ...state,
        error: null,
      };

    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
